<template>
  <div class="page-view">
    <!-- 面包屑 -->
    <a-breadcrumb class="page-breadcrumb">
      <a-breadcrumb-item>项目任务</a-breadcrumb-item>
      <a-breadcrumb-item>任务管理</a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 工具栏 -->
    <div class="tool-view">
      <!-- 时间 -->
      <a-range-picker
        style="width: 260px;"
        :allowClear="false"
        :value="startTime ? [moment(startTime, dateFormat), moment(endTime, dateFormat)] : undefined"
        @change="onTimeChange"
      />
      <!-- 项目 -->
      <a-select
        style="width: 260px; margin-left: 16px;"
        placeholder="请选择项目"
        allow-clear
        :getPopupContainer="getPopupContainer"
        v-model="projectID"
        @change="onSearch"
      >
        <a-select-option v-for="item in projectList" :key="item.id" :value="item.id">
          {{ item.name }}
        </a-select-option>
      </a-select>
      <!-- 搜索 -->
      <a-input-search
        v-model="searchModel"
        placeholder="请输入承接人合拍号或名称搜索"
        style="width: 260px; margin-left: 16px;"
        @search="onSearch"
      />
      <!-- 弹簧 -->
      <div style="flex: 1;"></div>
      <!-- 发布任务 -->
      <!-- <a-button type="primary" @click="touchNew">发布任务</a-button> -->
    </div>
    <!-- 列表 -->
    <a-table
      :columns="columns"
      :data-source="dataSource"
      :row-key="(record) => record.id"
      :pagination="pagination"
      :loading="isLoading"
      @change="handleTableChange"
    >
      <!-- 所属项目 -->
      <template slot="project_name" slot-scope="text, record">
        {{ record.project_id }}-{{ text }}
      </template>
      <!-- 任务状态 -->
      <template slot="status">
        已完成
      </template>
      <!-- 操作 -->
      <template slot="operate" slot-scope="text, record">
        <!-- a 标签 -->
        <a class="operate-item" @click="touchDetail(record)">详情</a>
      </template>
    </a-table>
    <!-- 任务详情 -->
    <TaskDetailDrawer ref="TaskDetailDrawer"></TaskDetailDrawer>
  </div>
</template>

<script>
import moment from 'moment'
import TaskDetailDrawer from './components-task-list/TaskDetailDrawer'
import { getTaskList, getProjectTaskAll } from '@/api/request'
// 列字段
const columns = [
  {
    title: '任务ID',
    dataIndex: 'number',
    key: 'number'
  },
  {
    title: '任务名称',
    dataIndex: 'task_name',
    key: 'task_name'
  },
  {
    title: '所属项目',
    dataIndex: 'project_name',
    key: 'project_name',
    scopedSlots: { customRender: 'project_name' }
  },
  {
    title: '任务金额',
    dataIndex: 'money',
    key: 'money'
  },
  {
    title: '发布人',
    dataIndex: 'lg_username',
    key: 'lg_username'
  },
  {
    title: '任务状态',
    dataIndex: 'status',
    key: 'status',
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '操作',
    dataIndex: 'operate',
    key: 'operate',
    scopedSlots: { customRender: 'operate' }
  }
]
export default {
  components: {
    TaskDetailDrawer
  },
 data () {
    return {
      moment,
      // 列字段
      columns,
      // 加载
      isLoading: false,
      // 数据源
      dataSource: [],
      // 分页器
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showSizeChanger: true
      },
      // 项目ID
      projectID: undefined,
      // 项目列表
      projectList: [],
      // 搜索
      searchModel: '',
      search: '',
      // 时间格式
      dateFormat: 'YYYY-MM-DD',
      // 时间范围
      startTime: undefined,
      endTime: undefined
    }
  },
  created () {
    // 初始化日期
    this.startTime = moment().subtract(30, 'days').format(this.dateFormat)
    this.endTime = moment().format(this.dateFormat)
    // 是否需要搜索
    const search = this.$route.query.search
    const projectID = this.$route.query.id
    if (!!search) {
      this.searchModel = search
    }
    if (!!projectID) {
      this.projectID = Number(projectID)
    }
    // 获取项目列表
    this.getProjectTaskAll()
    // 获取列表
    this.onSearch() 
  },
  methods: {
    // 分页
    handleTableChange (pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      // 获取任务列表
      this.getTaskList()
    },
    // 时间区间
    onTimeChange (date, dateString) {
      this.startTime = dateString[0]
      this.endTime = dateString[1]
      this.onSearch()
    },
    // 详情
    touchDetail (record) {
      this.$refs['TaskDetailDrawer'].showDrawer(record.id)
    },
    // 发布任务
    touchNew () {
      console.log('发布任务')
    },
    // 重新指定渲染控件
    getPopupContainer (triggerNode) {
      return triggerNode.parentNode
    },
    // 获取合作项目列表
    getProjectTaskAll () {
      getProjectTaskAll().then(res => {
        const { code, data, msg } = res
        if (code === 0) {
          this.projectList = data
        } else {
          this.$message.error(msg)
        }
      })
    },
    // 搜索
    onSearch () {
      // 记录
      this.search = this.searchModel
      // 初始页码
      this.pagination.current = 1
      // 获取任务列表
      this.getTaskList()
    },
    // 获取任务列表
    getTaskList () {
      this.isLoading = true
      const params = {
        project_id: this.projectID,
        kw: this.search,
        start_time: this.startTime,
        end_time: this.endTime,
        page: this.pagination.current,
        page_size: this.pagination.pageSize
      }
      getTaskList(params).then(res => {
        this.isLoading = false
        const { code, data, message } = res
        if (code === 0) {
          this.dataSource = data.data
          this.pagination.total = data.total
        } else {
          this.$message.error(message)
        }
      }).catch(() => {
        this.isLoading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.page-view {
  padding: 24px 32px;
}
.tool-view {
  padding: 24px 0;
  display: flex;
}
</style>